import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { confirmAlert } from "react-confirm-alert";
import { findByEvento, remove, save } from "./api-evento-aluno";
import AlunoFindDialog from "../../Aluno/AlunoFindDialog";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { errorToast } from "../../../util/ToastUtil";
import Loading from "../../UI/Loading";

export default function EventoAlunoTable({ evento }) {
  const [eventoAlunos, setEventoAlunos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    findByEvento(evento.codigo)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else {
          setEventoAlunos(data);
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [evento.codigo]);

  const handleAlunoSelected = (aluno) => {
    if (!aluno) return;
    save({ evento, aluno }).then((data) => {
      if (!data) return;
      if (data.error) {
        errorToast(`Aluno ${aluno.nome} já cadastrado.`);
        return;
      }
      setEventoAlunos((prevState) => [...prevState, data]);
    });
  };

  const handleDelete = (eventoAluno) =>
    confirmAlert({
      title: "Alerta",
      message: `Deseja remover ${eventoAluno.aluno.nome} do evento?`,
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            remove(eventoAluno.codigo).then((data) => {
              if (data?.error) {
                errorMessage(data.message);
                return;
              }
              setEventoAlunos((prevState) => prevState.filter((ea) => ea.codigo !== eventoAluno.codigo));
            });
          },
        },
        { label: "Não", onClick: () => {} },
      ],
    });

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2 }}>
      <AlunoFindDialog openSearch={open} setOpenSearch={setOpen} setAluno={handleAlunoSelected} />

      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} p={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="subtitle1" fontWeight={600}>
            Alunos
          </Typography>
          <Chip size="small" label={eventoAlunos.length} />
        </Stack>
        {!evento.enviado && (
          <Button size="small" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
            Adicionar
          </Button>
        )}
      </Stack>
      <Divider />

      {isLoading ? (
        <Box py={4}>
          <Loading size={28} description="Carregando alunos..." />
        </Box>
      ) : eventoAlunos.length === 0 ? (
        <Typography variant="body2" color="text.secondary" textAlign="center" py={4} px={2}>
          Nenhum aluno adicionado.
        </Typography>
      ) : (
        <List dense disablePadding sx={{ maxHeight: 420, overflowY: "auto" }}>
          {eventoAlunos.map((ea) => (
            <ListItem
              key={ea.codigo}
              divider
              secondaryAction={
                !evento.enviado && (
                  <Tooltip title="Remover aluno">
                    <IconButton edge="end" size="small" onClick={() => handleDelete(ea)}>
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )
              }
            >
              <ListItemText primary={ea.aluno.nome} />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
}
